import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.UserSettingsPage.components.Features.title',
    defaultMessage: 'Features',
  },
  subtitle: {
    id: 'containers.UserSettingsPage.components.Features.subtitle',
    defaultMessage: 'Features sub',
  },
  useSetting: {
    id: 'containers.UserSettingsPage.components.Features.useSetting',
    defaultMessage: 'Use setting',
  },
})
